// @flow
import DesktopTraceEventHandler from 'app/common/lib/TraceLogger/DesktopTraceEventHandler';
import HANDLER_CONFIGS from 'app/common/lib/TraceLogger/config';
import traceLogger from 'app/packages/trace-logger/singleton';
import { addAppInitAnnotation } from 'app/common/lib/TraceLogger/appInitAnnotations';
import { handleRouteChange } from 'app/packages/trace-logger/resourceTiming';
import type {
  StartTraceEvent,
  StopTraceEvent,
  AbortTraceEvent,
  CustomTraceEvent,
  PageReactRouterOnChangeTraceEvent,
  MetricName,
} from 'app/common/lib/TraceLogger/types';

const addHandlerIfNecessary = (metricName: MetricName) => {
  if (traceLogger.isDisabled()) {
    return;
  }
  const matchedConfig = HANDLER_CONFIGS.find((config) => metricName === config.metricName);
  if (!matchedConfig) {
    console.warn(`Trace for ${metricName} not found`); // eslint-disable-line no-console
    return;
  }
  if (!traceLogger.findHandlerByName(matchedConfig.traceName)) {
    traceLogger.addHandler(new DesktopTraceEventHandler(matchedConfig));
  }
};

export const startTiming = (
  metricName: MetricName,
  pageLoadData?: {|
    spanId: ?string,
    traceId: ?string,
  |},
) => {
  addHandlerIfNecessary(metricName);
  const event: StartTraceEvent = {
    name: 'start',
    metricName,
    ...(pageLoadData || {}),
  };
  traceLogger.sendEvent(event);
};

export const stopTiming = (
  metricName: MetricName,
  options?: {|
    result?: number,
    resultReason?: any,
    viewParameter?: number,
    gridImagesCached?: boolean,
  |},
) => {
  const event: StopTraceEvent = {
    name: 'stop',
    metricName,
    result: PCONST.thrift.UpwtStopReason.COMPLETE,
    ...options,
  };
  traceLogger.sendEvent(event);
};

export const abortTiming = (eventName: 'beforeunload' | 'popstate' | 'blur') => {
  const event: AbortTraceEvent = {
    name: 'PageAbortTraceEvent',
    eventName,
  };
  traceLogger.sendEvent(event);
};

export const logRouteChanged = () => {
  const event: PageReactRouterOnChangeTraceEvent = { name: 'PageReactRouterOnChangeTraceEvent' };
  traceLogger.sendEvent(event);
  handleRouteChange();
};

export const logCustomTraceEvent = (event: CustomTraceEvent) => {
  traceLogger.sendEvent(event);
};

export { addAppInitAnnotation };
